import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgEditField = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" {...props}>
    <path
      fill="none"
      stroke="#007AFF"
      d="M12.435.707 2.358 10.784l-1.203 3.18 3.334-1.068L14.556 2.828 12.435.708z"
    />
  </svg>
);
const Memo = memo(SvgEditField);
export default Memo;
